<template>
	<BaseCmsPage v-slot="{page}">
		<WebshopCheckoutLayout>
			<template #header>
				<WebshopCheckoutHeader :step="1" />
			</template>

			<template #wcCol2>
				<BaseWebshopCheckout>
					<div class="checkout-login">
						<div class="checkout-login-inner">
							<BaseCmsLabel class="gc-title" code="guest_checkout_title" tag="div" />
							<div class="wc-cnt" v-html="page?.content" />

							<BaseWebshopGuestForm class="form form-animated-label login-form guest-login" v-slot="{loading, fields}">
								<BaseFormField v-for="item in fields" :key="item.name" :item="item" v-slot="{errorMessage, floatingLabel}">
									<p class="field" :class="['field-' + item.name, {'ffl-floated': floatingLabel}]">
										<BaseFormInput id="guest-email" />
										<BaseCmsLabel tag="label" for="guest-email" :code="item.name" />
										<span class="error" v-show="errorMessage" v-html="errorMessage" />
									</p>
								</BaseFormField>
								<button class="btn btn-orange gc-btn" type="submit" :class="{'loading': loading}"><UiLoader size="small" v-if="loading" /><BaseCmsLabel code="continue_without_signup" /></button>
							</BaseWebshopGuestForm>

							<div class="checkout-login-form">
								<div class="checkout-auth-header">
									<BaseCmsLabel code="login_to_account" tag="div" class="checkout-auth-title" />
									<BaseCmsLabel code="login_subtitle" tag="div"  class="checkout-auth-subtitle" />
								</div>
								<AuthLoginForm mode="checkout" />
							</div>	
						</div>
					</div>
				</BaseWebshopCheckout>
			</template>
		</WebshopCheckoutLayout>
	</BaseCmsPage>
</template>

<style lang="less" scoped>
	.gc-title, .checkout-auth-title{
		display: block; font-size: 20px; line-height: 1.4; margin-bottom: 10px;
		@media (max-width: @m){font-size: 18px; margin-bottom: 7px;}	
	}
	.wc-cnt{
		display: block; font-size: 14px; line-height: 1.6; margin-bottom: 16px;
		:deep(p){padding-bottom: 0;}	
		@media (max-width: @m){font-size: 13px; margin-bottom: 14px;}
	}
	.guest-login{
		display: block; margin-bottom: 64px;
		p{padding-bottom: 12px;}
		@media (max-width: @m){margin-bottom: 28px;}
	}
	.gc-btn, :deep(.btn-checkout-login){
		padding-left: 32px; padding-right: 32px;
		&:after{font-size: 10px; margin-top: 1px;}	
		&.loading{color: #fff!important;}
		@media (max-width: @m){
			width: auto; padding: 16px 24px 13px; 
			&:after{margin-top: -1px;}
		}
	}
	//.gc-btn :deep(.inline svg){width: 30px; height: 30px; filter: brightness(0) invert(1);}
	.checkout-auth-subtitle{display: block; font-size: 12px; line-height: 1.2; font-weight: 700; color: var(--darkGray); margin-bottom: 12px;}
	:deep(.field-remember_me){
		input[type=checkbox] + label:before{top: -2px;}
		@media (max-width: @m){
			input[type=checkbox] + label:before{top: -1px;}
		}
	}
</style>